import React, {MutableRefObject, useContext, useEffect, useState} from 'react';
import {Alert, Button, Card, Col, ConfigProvider, DatePicker, Form, Input, InputNumber, Modal, Row, Select} from 'antd';
import Colors from "../../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import {Escola} from "../../../../model/root/Escola";
import {GetInscripcionsEscoles} from "../../../../dao/inscripcions/GetInscripcionsEscoles";
import {AuthContext} from "../../../../config/AuthContext";
import TextArea from "antd/es/input/TextArea";
import Activitat from "../../../../model/multilleure/casals/Activitat";
import Casal from "../../../../model/inscripcions/Casal";
import dayjs from "dayjs";
import {GetActivitats} from "../../../../dao/multilleure/GetActivitats";
import {CloseOutlined} from "@ant-design/icons";
import {PostCasal} from "../../../../dao/multilleure/casals/PostCasal";
import locale from "antd/es/locale/es_ES";

interface IngredientModalProps {
    element: Casal;
    visible: boolean;
    onClose: (value: boolean) => void;
    editar: boolean;
    ref1: MutableRefObject<null>;
    ref2: MutableRefObject<null>;
    ref3: MutableRefObject<null>;
    ref4: MutableRefObject<null>;
    ref5: MutableRefObject<null>;
    ref6: MutableRefObject<null>;
    ref7: MutableRefObject<null>;
    ref8: MutableRefObject<null>;
}

const CasalsModal: React.FC<IngredientModalProps> = ({element, visible, onClose, editar, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8}) => {
    const [form] = Form.useForm();
    const [escoles, setEscoles] = useState<Escola[]>([]);
    const [activitats, setActivitats] = useState<Activitat[]>([]);
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);

    const format = 'DD-MM-YYYY';

    useEffect(() => {
        //console.log(JSON.stringify(element));
        if(isLoggedIn){
            checkDades();
        }
    }, []);

    async function checkDades() {
        const dades = await GetInscripcionsEscoles(page);
        const dades2 = await GetActivitats(page);
        const dadesX = [{label: "No seleccionat", value: 0}, ...dades];
        const nouInici = dayjs(element.inici).format(format);
        const nouFin = dayjs(element.fin).format(format);
        const elementX = {...element, inici: nouInici, fin: nouFin};
        element = elementX;
        setEscoles(dadesX);
        setActivitats(dades2);
        //console.log(JSON.stringify(dades));
    }

    async function handleSubmit() {
        const formData = form.getFieldsValue();
        //console.log("Form Data:", formData);
        //console.log(JSON.stringify(formData));
        await PostCasal(formData, page);
        onClose(true);
    };

    const handleCancel = () => {
        onClose(false);
    };

    const extres = [
        {
            label: "si/no",
            value: "checkbox"
        },
        {
            label: "cantitat",
            value: "number"
        },
        {
            label: "Talla",
            value: "select"
        }
    ]
    const opcions = [
        {
            label: "Sense dies exporàdics",
            value: "noexporaidics"
        },
        {
            label: "Només dies exporàdics",
            value: "exporadics"
        },
        {
            label: "Ambdues opcións",
            value: "tot"
        }
    ]

    return (
        <ConfigProvider locale={locale}>
        <Modal
            title="CASAL"
            open={visible}
            onCancel={handleCancel}
            footer={[]}
            width={1000}
        >
            <Form form={form} initialValues={element} onFinish={handleSubmit} disabled={!editar}>
                <hr/>
                <Row gutter={[16, 16]} ref={ref2}>
                    <Col span={12}>
                        <Form.Item label="ID" name="id">
                            <Input disabled/>
                        </Form.Item>
                        <Form.Item label="Nom" name="nom"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input/>
                        </Form.Item>
                        <Form.Item label="Escola" name="idEscola"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select showSearch
                                    disabled={escoles.length === 0 || !editar}
                                    placeholder="Selecciona Escola"
                                    optionFilterProp="children"
                                    options={escoles}
                            />
                        </Form.Item>
                        <Form.Item label="Inici" name="inici"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <DatePicker type={"date"}
                                        format={format}/>
                        </Form.Item>
                        <Form.Item label="Final" name="fin"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <DatePicker type={"date"}
                                        format={format}/>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <div ref={ref3}>
                        <Form.Item label="Activitat" name="idActivitat"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select showSearch
                                    disabled={activitats.length === 0 || !editar}
                                    placeholder="Selecciona Activitat"
                                    optionFilterProp="children"
                                    options={activitats}
                            />
                        </Form.Item>
                        </div>
                        <Form.Item label="Escola Entrada 1" name="idEscola"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select showSearch
                                    disabled={true}
                                    placeholder="Escola d'entrada"
                                    optionFilterProp="children"
                                    options={escoles}
                            />
                        </Form.Item>
                        <Form.Item label="Escola Entrada 2" name="idEscolaEntrada1"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select showSearch
                                    disabled={escoles.length === 0 || !editar}
                                    placeholder="Selecciona Escola d'entrada alternativa"
                                    optionFilterProp="children"
                                    options={escoles}
                            />
                        </Form.Item>
                        <Form.Item label="Escola Entrada 3" name="idEscolaEntrada2"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select showSearch
                                    disabled={escoles.length === 0 || !editar}
                                    placeholder="Selecciona Escola d'entrada alternativa"
                                    optionFilterProp="children"
                                    options={escoles}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Form.Item label="Descripció" name="descripcio"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <TextArea/>
                        </Form.Item>
                    </Col>
                </Row>
                <h6>Configuració de Campus</h6>
                <hr/>
                <Row gutter={[16, 16]} ref={ref4}>
                    <Col span={24}>
                        <Form.List name="campus">
                            {(fields, {add, remove}) => (
                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                    {fields.map((field) => (
                                        <Card
                                            type="inner"
                                            size="small"
                                            title={`Campus ${field.name + 1}`}
                                            key={field.key}
                                            extra={
                                                <CloseOutlined hidden={!editar}
                                                               onClick={() => {
                                                                   remove(field.name);
                                                               }}
                                                />
                                            }
                                        >
                                            <Row gutter={[16, 16]}>
                                                <Col span={2}>
                                                    <Form.Item name={[field.name, 'id']}>
                                                        <InputNumber defaultValue={"0"} disabled/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={1}>
                                                </Col>
                                                <Col span={9}>
                                                    <Form.Item label="Nom Campus" name={[field.name, 'nom']}
                                                               rules={[{
                                                                   required: true,
                                                                   message: 'Aquest camp es obligatori'
                                                               }]}>
                                                        <Input/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12}>
                                                    <Form.Item label="Descripció" name={[field.name, 'descripcio']}
                                                               rules={[{
                                                                   required: true,
                                                                   message: 'Aquest camp es obligatori'
                                                               }]}>
                                                        <TextArea/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Card>
                                    ))}

                                    <Button style={{backgroundColor: Colors.colors.color6}} onClick={() => add()} block>
                                        + Afegir Nou Campus
                                    </Button>

                                    <Form.Item
                                        name="campus"
                                        rules={[
                                            {
                                                validator: async (_, value) => {
                                                    if (!fields || fields.length === 0) {
                                                        return Promise.reject(new Error('Has d’afegir almenys un campus.'));
                                                    }
                                                },
                                            },
                                        ]}
                                    >
                                        {/* Invisible input para disparar la validación */}
                                        <Input hidden />
                                    </Form.Item>
                                </div>
                            )}
                        </Form.List>
                    </Col>
                </Row>
                <br/>
                <h6>Configuracions Extres</h6>
                <hr/>
                <Row gutter={[16, 16]} ref={ref5}>
                    <Col span={24}>
                        <Alert message={"Afegir camps extres com samarretes, nit a la escola, etc..."} type={"info"}/>
                        <br/>
                        <Form.List name="extres">
                            {(fields, {add, remove}) => (
                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                    {fields.map((field) => (
                                        <Card
                                            type="inner"
                                            size="small"
                                            title={`Extra ${field.name + 1}`}
                                            key={field.key}
                                            extra={
                                                <CloseOutlined hidden={!editar}
                                                               onClick={() => {
                                                                   remove(field.name);
                                                               }}
                                                />
                                            }
                                        ><Row gutter={[16, 16]}>
                                            <Col span={2}>
                                                <Form.Item name={[field.name, 'id']}>
                                                    <InputNumber defaultValue={"0"} disabled/>
                                                </Form.Item>
                                            </Col>
                                            <Col span={1}>
                                            </Col>
                                            <Col span={9}>
                                                <Form.Item label="Nom" name={[field.name, 'nom']}
                                                           rules={[{
                                                               required: true,
                                                               message: 'Aquest camp es obligatori'
                                                           }]}>
                                                    <Input style={{width: "100%"}}/>
                                                </Form.Item>
                                            </Col>
                                            <Col span={6}>
                                                <Form.Item label="Tipus" name={[field.name, 'tipus']}
                                                           rules={[{
                                                               required: true,
                                                               message: 'Aquest camp es obligatori'
                                                           }]}>
                                                    <Select showSearch
                                                            placeholder="Selecciona Tipus"
                                                            optionFilterProp="children"
                                                            options={extres}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={6}>
                                                <Form.Item label="Preu" name={[field.name, 'preu']}>
                                                    <InputNumber
                                                        step="0.1" defaultValue={0.00} addonAfter="€"/>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                            <Row gutter={[16, 16]}>
                                                <Col span={24}>
                                                    <Form.Item label="Descripció" name={[field.name, 'descripcio']}
                                                               rules={[{
                                                                   required: true,
                                                                   message: 'Aquest camp es obligatori'
                                                               }]}>
                                                        <TextArea/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Card>
                                    ))}

                                    <Button style={{backgroundColor: Colors.colors.color6}} onClick={() => add()} block>
                                        + Afegir Extra
                                    </Button>
                                </div>
                            )}
                        </Form.List>
                    </Col>
                </Row>
                <br/>
                <h6>Configuracions Opcions</h6>
                <hr/>
                <Row gutter={[16, 16]}  ref={ref6}>
                    <Col span={24}>
                        <Alert
                            message={"Afegir les opcions de seleció: Matí, Matí i tarda, Menjador, Permanències, etc... A l'apartat Descompte cal especificar el descompte que s'aplica a cada setmana per agafar més d'una."}
                            type={"info"}/>
                        <br/>
                        <Form.List name="opcions">
                            {(fields, {add, remove}) => (
                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                    {fields.map((field) => (
                                        <Card
                                            type="inner"
                                            size="small"
                                            title={`Opció ${field.name + 1}`}
                                            key={field.key}
                                            extra={
                                                <CloseOutlined hidden={!editar}
                                                               onClick={() => {
                                                                   remove(field.name);
                                                               }}
                                                />
                                            }
                                        >
                                            <Row gutter={[16, 16]}>
                                                <Col span={2}>
                                                    <Form.Item name={[field.name, 'id']}>
                                                        <InputNumber defaultValue={"0"} disabled/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={1}>
                                                </Col>
                                                <Col span={9}>
                                                    <Form.Item label="Nom" name={[field.name, 'nom']}
                                                               rules={[{
                                                                   required: true,
                                                                   message: 'Aquest camp es obligatori'
                                                               }]}>
                                                        <Input style={{width: "100%"}}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={6}>
                                                    <Form.Item label="Tipus" name={[field.name, 'tipus']}
                                                               rules={[{
                                                                   required: true,
                                                                   message: 'Aquest camp es obligatori'
                                                               }]}>
                                                        <Select showSearch
                                                                placeholder="Selecciona Tipus"
                                                                optionFilterProp="children"
                                                                options={opcions}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={6}>
                                                    <Form.Item label="Preu setmana" name={[field.name, 'preu']}>
                                                        <InputNumber step="0.1" defaultValue={0.00} addonAfter="€"/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={[16, 16]}>
                                                <Col span={6}>
                                                    <Form.Item label="Preu dia" name={[field.name, 'preu2']}>
                                                        <InputNumber step="0.1" defaultValue={0.00} addonAfter="€"/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={6}>
                                                    <Form.Item label="Desc. Setmana" name={[field.name, 'descompte']}>
                                                        <InputNumber step="0.1" defaultValue={0.00} addonAfter="%"/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={6}>
                                                    <Form.Item label="Desc. Anticipat" name={[field.name, 'descompte2']}>
                                                        <InputNumber step="0.1" defaultValue={0.00} addonAfter="%"/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={6}>
                                                    <Form.Item label="Desc. Germans" name={[field.name, 'descompte3']}>
                                                        <InputNumber step="0.1" defaultValue={0.00} addonAfter="%"/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={[16, 16]}>
                                                <Col span={24}>
                                                    <Form.Item label="Descripció" name={[field.name, 'descripcio']}
                                                               rules={[{
                                                                   required: true,
                                                                   message: 'Aquest camp es obligatori'
                                                               }]}>
                                                        <TextArea/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Card>
                                    ))}

                                    <Button style={{backgroundColor: Colors.colors.color6}} onClick={() => add()} block>
                                        + Afegir Nova Opció de Casal
                                    </Button>

                                    <Form.Item
                                        name="opcions"
                                        rules={[
                                            {
                                                validator: async (_, value) => {
                                                    if (!fields || fields.length === 0) {
                                                        return Promise.reject(new Error('Has d’afegir almenys una opció.'));
                                                    }
                                                },
                                            },
                                        ]}
                                    >
                                        {/* Invisible input para disparar la validación */}
                                        <Input hidden />
                                    </Form.Item>
                                </div>
                            )}
                        </Form.List>
                    </Col>
                </Row>
                <hr/>
                <Row gutter={[16, 16]}>
                    <Col span={1}>
                        <Form.Item wrapperCol={{offset: 0, span: 16}}>
                            <Button title={"Aceptar"} htmlType={"submit"} disabled={!editar} ref={ref7}
                                    style={{backgroundColor: Colors.colors.color6}}><BiCheck/></Button>
                        </Form.Item>
                    </Col>
                    <Col span={1}>
                    </Col>
                    <Col span={1}>
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </Col>
                </Row>
            </Form>
        </Modal>
        </ConfigProvider>
    );
};

export default CasalsModal;
